module.exports = __webpack_public_path__ + "img/image-17.cee0124c.jpg";